import config from 'config';

export const primaryLight = '#008adc';
export const primaryMedium = config.primary_medium_color;

export const redMedium = '#E63C3C';

export const whiteLight = '#ffffff';
export const whiteMedium = '#f9f9f9';
export const whiteHard = '#f3f3f3';

export const grayLight = '#ececec';
export const grayHard = '#8d8d8d';
export const grayMedium = '#bbbbbb';

export const blackLight = '#616161';
export const blackMedium = '#282828';

/* Accessible colors */

export const primaryLightAccessible = '#14A5A7';
export const primaryMediumAccessible = '#1B8384';

export const redMediumAccessible = '#C81515';

